import React from "react";

const BeforeLoader = () => {
  return (
    <div className="s-min-h-full-with-header s-pb-20px">
      <div className="s-px-2">
        <div className="s-border s-border-black-300 dark:s-border-black-700 s-shadow s-rounded-md s-py-4 s-px-4 s-mb-3 dark:s-opacity-85">
          <div className="s-flex s-space-x-4">
            <div className="s-flex-1 s-space-y-4 s-py-1">
              <div className="s-flex s-justify-start s-items-center">
                <div className="s-w-4 s-h-4 s-rounded-full s-bg-skeleton-gradient dark:s-bg-skeleton-gradient-dark s-bg-400% s-animate-skeleton" />
                <div className="s-w-1/4 s-h-4 s-ml-1 s-rounded s-bg-skeleton-gradient dark:s-bg-skeleton-gradient-dark s-bg-400% s-animate-skeleton" />
              </div>
              <div className="s-space-y-2">
                <div className="s-h-4 s-rounded s-bg-skeleton-gradient dark:s-bg-skeleton-gradient-dark s-bg-400% s-animate-skeleton" />
                <div className="s-h-4 s-rounded s-w-5/6 s-bg-skeleton-gradient dark:s-bg-skeleton-gradient-dark s-bg-400% s-animate-skeleton" />
              </div>
            </div>
          </div>
        </div>
        <div className="s-border s-border-black-300 dark:s-border-black-700 s-shadow s-rounded-md s-py-4 s-px-4 s-mb-3 dark:s-opacity-85">
          <div className="s-flex s-space-x-4">
            <div className="s-flex-1 s-space-y-4 s-py-1">
              <div className="s-flex s-justify-start s-items-center">
                <div className="s-w-4 s-h-4 s-rounded-full s-bg-skeleton-gradient dark:s-bg-skeleton-gradient-dark s-bg-400% s-animate-skeleton" />
                <div className="s-w-1/4 s-h-4 s-ml-1 s-rounded s-bg-skeleton-gradient dark:s-bg-skeleton-gradient-dark s-bg-400% s-animate-skeleton" />
              </div>
              <div className="s-space-y-2">
                <div className="s-h-4 s-rounded s-bg-skeleton-gradient dark:s-bg-skeleton-gradient-dark s-bg-400% s-animate-skeleton" />
                <div className="s-h-4 s-rounded s-w-5/6 s-bg-skeleton-gradient dark:s-bg-skeleton-gradient-dark s-bg-400% s-animate-skeleton" />
              </div>
            </div>
          </div>
        </div>
        <div className="s-border s-border-black-300 dark:s-border-black-700 s-shadow s-rounded-md s-py-4 s-px-4 s-mb-3 dark:s-opacity-85">
          <div className="s-flex s-space-x-4">
            <div className="s-flex-1 s-space-y-4 s-py-1">
              <div className="s-flex s-justify-start s-items-center">
                <div className="s-w-4 s-h-4 s-rounded-full s-bg-skeleton-gradient dark:s-bg-skeleton-gradient-dark s-bg-400% s-animate-skeleton" />
                <div className="s-w-1/4 s-h-4 s-ml-1 s-rounded s-bg-skeleton-gradient dark:s-bg-skeleton-gradient-dark s-bg-400% s-animate-skeleton" />
              </div>
              <div className="s-space-y-2">
                <div className="s-h-4 s-rounded s-bg-skeleton-gradient dark:s-bg-skeleton-gradient-dark s-bg-400% s-animate-skeleton" />
                <div className="s-h-4 s-rounded s-w-5/6 s-bg-skeleton-gradient dark:s-bg-skeleton-gradient-dark s-bg-400% s-animate-skeleton" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BeforeLoader;
